export enum DeliveryMethods {
  Pickup = 'pickup',
  Delivery = 'delivery',
  Table = 'table',
}
